var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconionicMdMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.152,
    height: 16.619,
    viewBox: "0 0 21.152 16.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-megaphone",
    "data-name": "Icon ionic-md-megaphone",
    transform: "translate(-2.25 -5.625)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11813",
    "data-name": "Trac\\xE9 11813",
    d: "M26.333,10.083l-1.091,1.086a3.841,3.841,0,0,1,0,5.439L26.333,17.7a5.386,5.386,0,0,0,0-7.616Z",
    transform: "translate(-7.553 -1.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11814",
    "data-name": "Trac\\xE9 11814",
    d: "M29.583,6.961,28.512,8.033a6.839,6.839,0,0,1,0,9.66l1.072,1.072a8.344,8.344,0,0,0,0-11.8Z",
    transform: "translate(-8.627 -0.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11815",
    "data-name": "Trac\\xE9 11815",
    d: "M15.847,10.54V5.625H14.337L9.8,9.4H3.761l-1.511.755v5.288l1.511.755,3.777,6.043H9.8L8.388,16.2H9.8l4.532,3.022h1.511V14.308a1.789,1.789,0,0,0,1.511-1.884A1.789,1.789,0,0,0,15.847,10.54Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicMdMegaphone);
export default __webpack_public_path__ + "static/media/Icon ionic-md-megaphone.8258957e75e3c24a329f0085ef77bca3.svg";
export { ForwardRef as ReactComponent };